import React, {Fragment} from 'react';
import {Icon, Typography} from '@bonprix/design-system';
import Benefit from '@checkout/components/cart/Benefit.jsx';
import AcceptedPaymentSection from './AcceptedPaymentSection.jsx';

export default function BenefitsSection({texts, country, paymentTypes, guest}) {
    const getBenefitsForCountry = (country) => {
        switch (country) {
            case 'de':
                const text = (texts.cot09_parcelshop_delivery_text)
                    .replace('{0}', texts.cot09_delivery_to_parcelshop_shipping_charges)
                    .replace('{1}', texts.cot09_delivery_to_address_shipping_charges);
                return (
                    <>
                        <Benefit
                            icon={<Icon variant="return" />}
                            heading={texts.cot19_free_return}
                            text={texts.cot09_benefits_free_return_text} />
                        <Benefit
                            icon={<Icon variant="lock" />}
                            heading={texts.cot19_secure_payment}
                            text={texts.bff_secure_data_transfer} />
                        <Benefit
                            icon={<Icon variant="location" />}
                            heading={texts.cot09_parcelshop_delivery}
                            text={text} />
                    </>
                );
            case 'at':
                return (
                    <>
                        <Benefit
                            icon={<Icon variant="return" />}
                            heading={texts.cot19_free_return}
                            text={texts.cot09_benefits_free_return_text} />
                        <Benefit
                            icon={<Icon variant="lock" />}
                            heading={texts.cot19_secure_payment}
                            text={texts.bff_secure_data_transfer} />
                        <Benefit
                            icon={<Icon variant="location" />}
                            heading={texts.cot09_parcelshop_delivery}
                            text={texts.cot09_parcelshop_delivery_text} />
                    </>
                );
            default:
                return;
        }
    };

    return (
        <>
            <div className="cart__protected-submission cart__protected-submission--benefits">
                <Icon variant="lock" className="text-clr-on-bg-mid" />
                <span className="cart__protected-submission-message">
                    <Typography component="span" color="on-bg-mid">{texts.bff_secure_data_transfer}</Typography>
                </span>
            </div>

            { paymentTypes?.length !== 1 &&
                <div className="cart__benefits__accepted-payment-section">
                    <AcceptedPaymentSection texts={texts} paymentTypes={paymentTypes} country={country} guest={guest} isCartPage={true}/>
                </div>
            }

            <div className="cart__divider--viewport-width mt-6" />

            <div className="cart__benefits">
                <div className="cart__benefits__wrapper">
                    {getBenefitsForCountry(country)}
                </div>
            </div>
        </>
    );
}
